import React from "react";
import api from "../../../api/Api";
import Loader from "../../../components/Loader";
import {NavLink} from "react-router-dom";

import Icon from "@material-ui/core/Icon";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";


class ClinicRoleView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null, checkedItems: [], permissions: null

        }
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(e) {
        const state = this.state.checkedItems;
        state[e.target.name] = e.target.checked;
        this.setState(state);
    }

    componentDidMount() {
        this.CallReadApi(this.props.match.params.id)
    }

    render() {
        const {data} = this.state;
        if (this.state.data === undefined)
            return (<div><h1 style={{textAlign: 'center'}} className="text-center">No Access</h1></div>)
        if (this.state.data !== null && this.state.permissions !== null)
            return (<div>
                <div>
                    <Card>
                        <CardHeader color="info" text>
                            <CardText color="info">
                                <h4>Clinic Master Role Details</h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            { data ? data.map((x, y) =>
                                <GridContainer key={x._id}>
                                    <GridItem xs={12}>
                                        <h2 style={{margin: 20}}>{x.clinicmaster_name}</h2>
                                    </GridItem>
                                    <GridItem xs={12} sm={8} md={8}>
                                        <div style={{margin: 20}}>
                                            <br></br>
                                            <h4><b>Role Name:</b> {x.role_name} </h4>
                                            <h4><b>Access</b></h4>

                                            <h3>
                                                <ul>
                                                    {x.role_access.map((item, i) => <li key={i}>{item}</li>)
                                                    }
                                                </ul>
                                            </h3>

                                            {/*<h3>*/}
                                            {/*Permissions: </h3>*/}

                                            {/*{*/}
                                            {/*this.state.permissions.map(item => (*/}
                                            {/*<label key={item.key}>*/}
                                            {/*{this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}*/}
                                            {/*{item.permission_label}*/}
                                            {/*<br/>*/}
                                            {/*</label>*/}
                                            {/*))*/}
                                            {/*}*/}

                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={4} md={3} style={{marginTop: 50}}>
                                        <div>
                                            <a href={`/clinic/role/update/${x.clinic_master_id}/${x._id}`}>
                                                <Button block size="lg" color="warning">
                                                    <Icon>border_color</Icon>
                                                    <span style={{paddingLeft: 10}}>Update</span>
                                                </Button>
                                            </a>
                                        </div>

                                    </GridItem>
                                </GridContainer>) : null}
                        </CardBody>
                    </Card>

                </div>
            </div>)
        else
            return (
                <div>
                    <Loader/>
                </div>
            )
    }

    CallReadApi = (id) => {
        api.getAllPermissionList().then(json => {
            this.setState({permissions: json.data})
        });
        api.getPermissionForClinic(id).then(json => {
            this.setState({data: json.data})
        });
    }

    Checkbox = (name, checked) => (
        <input type={'checkbox'} name={name} checked={checked} onChange={this.handleChange}/>
    );
}

export default ClinicRoleView


// WEBPACK FOOTER //
// ./src/views/Roles/Clinic/ClinicRoleView.jsx